

<section>

  <div class="surface-section py-4 border-top-1 surface-border">
    <div class="container-lg mx-auto content">
  
      
      <div class="logo">
        <img src="assets/images/logos/Logo-Lektory-color.svg" class="w-9rem mx-auto lg:mx-0" alt="Lektory">
        <span class="text-900 block mt-4">
          Lektory je <b>systém</b> pro <b>organizaci a prodej kurzů</b>, workshopů, festivalů, konferencí a dalších on-line či on-site událostí. Vyřeší za vás administrativu a vy se tak můžete věnovat více tomu co vás baví.
        </span>
      </div>
      <div class="divider_a"></div>
      <div class="divider_b"></div>
      <div class="contact">
        <div class="flex flex-column">
          <span class="text-900 text-xl font-medium block">Kontaktní údaje</span>
          <ul class="list-none p-0">
            <li><a tabindex="0" class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-2 block">
              Magic Education, s.r.o.
            </a></li>
            <li><a tabindex="0" class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-2 block">
              IČ.: 07975040
            </a></li>
            <li><a tabindex="0" class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-2 block">
              info&#64;lektory.app
            </a></li>
          </ul>
        </div>
      </div>

      <div class="menu">
        <div class="flex flex-column">
          <span class="text-900 text-xl font-medium block">Pro uživatele</span>
          <ul class="list-none p-0">
            <li><a tabindex="0" class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-2 block">
              Obchodní podmínky
            </a></li>
            <li><a tabindex="0" class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-2 block">
              Ochrana osobních údajů
            </a></li>
            <li><a tabindex="0" class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-2 block">
              Návody použití
            </a></li>
          </ul>
        </div>
      </div>

      <div class="newsletter">
        
          <div id="f-1-43c2cd496486bcc27217c3e790fb4088"></div>
      </div>
    </div>
  </div>

  <div class="gradient py-6 lg:py-4 md:px-6 lg:px-8 flex flex-column lg:flex-row justify-content-between align-items-center">
    <ul class="list-none p-0 mb-0 flex flex-column md:flex-row flex-order-1 lg:flex-order-0 mt-4 lg:mt-0">

      <li class="mr-4 mt-3 lg:mt-0">
        <span class="text-500 block text-center">© 2023, Magic Education, s.r.o.</span>

          <!-- <a tabindex="0" class="cursor-pointer text-0">Investor Relations</a> -->
      </li>
      <!-- <li class="mr-4 mt-3 lg:mt-0">
          <a tabindex="0" class="cursor-pointer text-0">Data Privacy</a>
      </li>
      <li class="mr-4 mt-3 lg:mt-0">
          <a tabindex="0" class="cursor-pointer text-0">Terms of Service</a>
      </li>
      <li class="mr-4 mt-3 lg:mt-0">
          <a tabindex="0" class="cursor-pointer text-0">Legal Information</a>
      </li> -->
    </ul>

    <div class="flex align-items-center flex-order-0 lg:flex-order-1">
      <!-- <a tabindex="0" class="cursor-pointer mr-3 lg:mt-0 block">
        <i class="pi pi-facebook surface-section p-1 text-sm border-circle text-900"></i>
      </a>
      <a tabindex="0" class="cursor-pointer mr-3 lg:mt-0 block">
        <i class="pi pi-twitter surface-section p-1 text-sm border-circle text-900"></i>
      </a>
      <a tabindex="0" class="cursor-pointer mr-3 lg:mt-0 block">
        <i class="pi pi-youtube surface-section p-1 text-sm border-circle text-900"></i>
      </a>
      <a tabindex="0" class="cursor-pointer lg:mt-0 block">
        <i class="pi pi-google surface-section p-1 text-sm border-circle text-900"></i>
      </a> -->
    </div>
  </div>

</section>

<!-- 
<script>
  (function (w,d,s,o,f,js,fjs) {
      w['ecm-widget']=o;w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
      js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
      js.id = '1-43c2cd496486bcc27217c3e790fb4088'; js.dataset.a = 'lektory'; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);
  }(window, document, 'script', 'ecmwidget', 'https://d70shl7vidtft.cloudfront.net/widget.js'));
</script> -->
